import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCountry } from '../../hooks/useCountry';

const NotFound = () => {
  const { theme, isSubdomain } = useCountry();
  const { t } = useTranslation();
  const colors = theme?.colors || {};

  return (
    <div className={isSubdomain ? 'flex flex-col items-center justify-center py-16 sm:py-24 px-4' : 'min-h-screen bg-gray-50 flex flex-col'}>
      {/* Header - only on main domain */}
      {!isSubdomain && (
        <header className="bg-white shadow-sm">
          <div className="max-w-4xl mx-auto px-4 py-4">
            <Link to="/" className="text-2xl font-bold text-blue-600 hover:text-blue-700">RentyDoc</Link>
          </div>
        </header>
      )}

      <div className={isSubdomain ? 'text-center' : 'flex-1 flex items-center justify-center px-4'}>
        <div className="text-center">
          <h1 className="text-9xl font-bold" style={{ color: theme ? `${colors.primary}20` : '#e5e7eb' }}>{t('pages.notFound.code')}</h1>
          <h2 className="text-3xl font-bold text-gray-900 mt-4 mb-2">{t('pages.notFound.title')}</h2>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            {t('pages.notFound.text')}
          </p>
          <div className="space-x-4">
            <Link
              to="/"
              className="inline-block px-6 py-3 text-white rounded-lg font-medium transition-colors"
              style={{ background: theme ? colors.buttonBg : '#2563eb' }}
            >
              {t('pages.notFound.home')}
            </Link>
            <Link
              to="/contact"
              className="inline-block px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              {t('pages.notFound.contact')}
            </Link>
          </div>
        </div>
      </div>

      {/* Footer - only on main domain */}
      {!isSubdomain && (
        <footer className="bg-gray-800 text-white py-6">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <p className="text-gray-400">&copy; 2025 RentyDoc. All rights reserved.</p>
          </div>
        </footer>
      )}
    </div>
  );
};

export default NotFound;
